import { takeEvery, call, put, all } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import { fetchUserMenusApi } from "../../../api/endpoint";

function* getUserMenuSaga(action) {
  try {
    const _api = yield call(fetchUserMenusApi, action.payload);
    if (_api.data.results?.length === 0) {
      yield put(commonActions.setuserAvailability(false));
    }
    yield put(actions.setMenus(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    console.log(error);
    // yield put(commonActions.setLoading(false));
  }
}

export function* watchUserMenuSaga() {
  yield all([takeEvery(actionTypes.GET_MENUS, getUserMenuSaga)]);
}
